















import Vue, { PropType } from 'vue'

type TipoDeMensagem = 'observacao' | 'informacao' | 'erro' | 'sucesso'

enum TipoDeMensagemLegenda {
  'observacao' = 'Observação',
  'informacao' = 'Informação',
  'erro' = 'Erro',
  'sucesso' = 'Sucesso',
}

interface Computed {
  legendaTipo: string;
  classesMensagemDeObservacao: Record<string, boolean>;
}

interface Props {
  titulo: string;
  mensagem: string;
  tipo: TipoDeMensagem;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: 'MensagemDeObservacao',

  props: {
    titulo: {
      type: String as PropType<string>,
      required: false
    },
    tipo: {
      type: String as PropType<TipoDeMensagem>,
      required: false,
      default: 'observacao'
    },
    mensagem: {
      type: String as PropType<string>,
      required: true
    }
  },

  computed: {
    legendaTipo (): string {
      const configuracao = {
        observacao: TipoDeMensagemLegenda.observacao,
        informacao: TipoDeMensagemLegenda.informacao,
        erro: TipoDeMensagemLegenda.erro,
        sucesso: TipoDeMensagemLegenda.sucesso
      }
      return configuracao[this.tipo]
    },

    classesMensagemDeObservacao (): Record<string, boolean> {
      const {tipo} = this
      const classeModificadora = `mensagem-de-observacao--${tipo}`
      return {
        [classeModificadora]: true
      }
    }
  }
})
